/*
 * Kept apart from the pages: the router validates `?tab=` with it, and
 * importing it from a page would pull that lazily loaded page into the
 * start-up bundle.
 */

/**
 * The section's views, each at `/api-access/<view>` (docs/api-keys.md). Until
 * 2026-10-22 they were tabs of `/api-access?tab=`; that address still leads
 * to the view.
 */
export const API_TABS = [
  "keys",
  "service-accounts",
  "policies",
  "endpoints",
  "approvals",
  "apps",
  "activity",
] as const;
export type ApiTab = (typeof API_TABS)[number];

/** The views shown as tabs of «Ключи»; the others are subsections of the menu. */
export const KEY_VIEWS = ["keys", "service-accounts", "endpoints", "activity"] as const;
/**
 * Kinds of messenger connectors on «Мессенджеры» (`/api-access/messengers`),
 * in the order they are listed; a new messenger adds its kind here.
 */
export const MESSENGER_KINDS = ["telegram"] as const;
export type MessengerKind = (typeof MESSENGER_KINDS)[number];
